import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum KnowledgeBaseDocumentType {
  functionDescription = '1',
  businessRule = '2',
  operationManual = '3',
  // TODO: [AI-1144] AI-1111(PR#4742)で新DocumentTypeをコメントアウトの形で追加・定義押さえ。後続対策はAI-1144としてToDo化起票。
  // dataAnalysisReport = '4',
}

const nameConfig = {
  functionDescription: new Map([
    [Locale.ja, '機能説明'],
    [Locale.en, 'Function Description'],
  ]),
  businessRule: new Map([
    [Locale.ja, '業務ルール'],
    [Locale.en, 'Business Rule'],
  ]),
  operationManual: new Map([
    [Locale.ja, '操作マニュアル'],
    [Locale.en, 'Operation Manual'],
  ]),
  dataAnalysisReport: new Map([
    [Locale.ja, 'データ分析'],
    [Locale.en, 'Data Analysis Report'],
  ]),
};

const toEnum = rawValueToEnum(KnowledgeBaseDocumentType, KnowledgeBaseDocumentType.functionDescription);
const toDisplay = enumToName(KnowledgeBaseDocumentType, nameConfig);
const toDisplayWithPrefix = enumToName(KnowledgeBaseDocumentType, nameConfig, { prefix: true });

export const knowledgeBaseDocumentType = {
  enum: KnowledgeBaseDocumentType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { KnowledgeBaseDocumentType };
